import sty from '../Settings.module.css';

const SocialInformation = () =>{
    return (
        <form className={sty['form']}>
            <div className="inner-container">
                <div className={`${sty['form__label-flex-settings']} ${sty['form__label-flex-mb']} ${sty['update__line-break']}`}>
                    Googleアカウントでログイン中です。<br/>
                    各種変更はGoogleアカウント側で行ってください。
                </div>
            </div>
        </form>
    )
}
export default SocialInformation;